export const MESSAGES_OUTBOX_TAB_LOAD_DATA = "MESSAGES_OUTBOX_TAB_LOAD_DATA";
export const MESSAGES_OUTBOX_TAB_LOAD_DATA_RESULT = "MESSAGES_OUTBOX_TAB_LOAD_DATA_RESULT";